export default {
      id: "icon-instagram-usage",
      viewBox: "0 0 36 36",
      url: __webpack_public_path__ + "img/icons.10719bc6.svg#icon-instagram",
      toString: function () {
        return this.url;
      }
    }